import React, { ElementType, FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';

import { Button, Carousel, MinimalNumber } from '@savebetter/components';

import { LinkProps } from './Link';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { Section } from './Section';

interface NumberItem extends SbBlokData {
  value: string;
  description: string;
}

export interface Blok extends PageSectionBlok {
  title: string;
  subtitle?: string;
  numbers: NumberItem[];
  button: LinkProps[];
}

interface NumbersProps extends PageSectionProps {
  blok: Blok;
  sectionTitleWrapper?: ElementType | null;
}

export const Numbers: FunctionComponent<React.PropsWithChildren<NumbersProps>> = ({
  blok,
  sectionClassName,
  sectionTitleWrapper = null
}) => {
  const {
    hasBackground,
    hasBorder,
    title,
    subtitle,
    numbers = [],
    button: buttons = [],
    hasPaddingTop,
    hasPaddingBottom
  } = blok;
  const SectionTitle = sectionTitleWrapper || PageSectionHeader;
  const slides = numbers.map(number => {
    const { _uid, value, description } = number;

    return (
      <MinimalNumber
        key={_uid}
        {...storyblokEditable(number)}
        heading={value}
        headingColor="text-primary"
        description={description}
        className="minimalNumber"
      />
    );
  });
  const [button] = buttons;

  return (
    <Section
      width="sm"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClassName}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <SectionTitle className="text-center">{title}</SectionTitle>
      {subtitle && <h3>{subtitle}</h3>}
      <Carousel
        contentLabel={title}
        slides={slides}
        settings={{ lg: { slidesPerPage: Math.min(5, slides.length) } }}
        useDefaultSlideWrapper={false}
      />
      {button && (
        <div className="text-center mt-12 md:-mt-2">
          <Button href={button.url} target={button.target} className="inline-flex">
            {button.text}
          </Button>
        </div>
      )}
    </Section>
  );
};
